export default "__VITE_ASSET__CpiGDqn1__"